// extracted by mini-css-extract-plugin
module.exports = {"reveal":"styles_reveal__GUrH0","scroll":"styles_scroll__IlFsX","fadeInUp":"styles_fadeInUp__nhadU"};